import { Line } from "react-chartjs-2";
import { standardDeviationAnnotations, getDayAnnotations } from "./LineChartAnnotations";
import { StandardDeviationPlugin, calculateMean, drawSD } from "./StandardDeviationPlugin";
import { Chart } from "chart.js"
import { AVERAGE } from "./chartService";

Chart.register(
    StandardDeviationPlugin,
)
const getScaleValues = (trueMin, trueMax, stepSize, unitMap, sensor, showSD) => {
    if (!trueMin || !trueMax || !unitMap.hasOwnProperty(sensor.name))
        return {}
    const offset = 15 * stepSize[sensor.name]
    return {
        min: trueMin?.[sensor.name] ? trueMin[sensor.name] - offset : 0,
        max: trueMax?.[sensor.name] ? trueMax[sensor.name] + offset : 0,
        stepSize: stepSize[sensor.name],
        title: {
            display: true,
            text: unitMap[sensor.name]
        }
    }
}
const findSensorDataAtPoint = (thisDeviceLabel, datasets, dataindex) => {
    let deviceDataStr = []
    datasets?.forEach(deviceDataset => {
        if(thisDeviceLabel !== deviceDataset.label){
            const unit = deviceDataset.unit
            deviceDataStr.push(`${deviceDataset.label} : ${deviceDataset.data[dataindex].toFixed(2)} ${unit}`)
        }
    })
    return deviceDataStr
}
const showSensorVals = (ctx) => {
    //Gets the canvas ctx object and can extract various values about the data from there
    //https://www.chartjs.org/docs/latest/configuration/tooltip.html
    let sum = 0;
    const datasets = ctx.chart.data.datasets
    const dataIndex = ctx.dataIndex
    const timestamp = ctx.label
    const index = ctx.dataIndex
    let newMax, newMin = 0

    for (let i = 1; i < datasets.length; i++) { // Find the minimum and maximum pressure points on a given timestamp
        if (i === 1) {
          newMin = datasets[i].data[index]
          newMax = datasets[i].data[index]
        }
        let oldMax = newMax
        let oldMin = newMin

        newMax = datasets[i].data[index]
        newMin = datasets[i].data[index]

        if (newMax < oldMax) { newMax = oldMax }
        if (newMin > oldMin) { newMin = oldMin }
    }
    const thisDeviceDataset = ctx.dataset
    const thisDeviceLabel = ctx.dataset.label
    let sensorData = findSensorDataAtPoint(thisDeviceLabel, datasets, dataIndex)
    // let mean = calculateMean(thisDeviceDataset.data)

    const unit = thisDeviceDataset.unit;


    return [
        // `${timestamp} : ${thisDeviceDataset.data[dataIndex].toFixed(2)} ${unit}`,
        `Min: ${newMin.toFixed(2)}  ${unit}` ,
        `Max: ${newMax.toFixed(2)}  ${unit}`,
        // `Mean ${mean.toFixed(2)}  ${unit}`,
        ...sensorData
    ];
};
function LineChart({ id, data, trueMax, trueMin, stepSize, unitMap, sensor, groupId, showSD, showAvg, sensorsOnGraph, setSensorsOnGraph }) {
    // Chart data style and axis configuration

    const avgAnnotations = showAvg ? [
        ...standardDeviationAnnotations,
    ] : []
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                onClick: function (e, legendItem, legend) {
                    const index = legendItem.datasetIndex;
                    const ci = legend.chart;
                    if (ci.isDatasetVisible(index)) {
                        ci.hide(index);
                        ci.data.datasets[index].hidden = true;
                        const name = ci.data.datasets[index].label;
                        setSensorsOnGraph(sensorsOnGraph.filter(sensorName => sensorName !== name))
                        legendItem.hidden = true;
                    } else {
                        ci.data.datasets[index].hidden = false;
                        const name = ci.data.datasets[index].label;
                        setSensorsOnGraph([...sensorsOnGraph, name])
                        ci.show(index);
                        legendItem.hidden = false;
                    }
                }
            },
            title: {
                position: 'bottom',
                display: true,
                text: `Sensor group ${groupId} ${sensor.name.toUpperCase()} ${sensor.unit}`,
            },
            annotation: {
                annotations: [...avgAnnotations, ...getDayAnnotations(data.labels)]
            },
            tooltip: {
                callbacks: {
                    label: showSensorVals,
                    title: (ctx) => {
                        const thisData = ctx[0]
                        return `${thisData.label} : ${thisData.formattedValue} ${thisData.dataset.unit}`
                    }
                }
            },
            standardDev: (chart, args, options) => StandardDeviationPlugin(chart, args, options)
        },

        scales: {
            y: getScaleValues(trueMin, trueMax, stepSize, unitMap, sensor),
        },
    };
    return (<>
        <Line data={data} options={options} />
    </>);
}

export default LineChart;
